<script>
	import Variant from './Variant.svelte';
	export let variants, weight
	export let onSelect = () => {}

	let glass = 0
	let step = 1
	let selected = {}
	let deliverys = false

	$: {
		if(step === 1) {
			deliverys = false
			glass = 0
		}

		if(glass != 0) step++
		
	}

	function order(){
		onSelect({
			selected, glass
		})
	}

	function scroll(){
		deliverys = true
		setTimeout(() => {
				window.scrollBy(0, 300)	
		}, 500);
		
		let yOffset = window.pageYOffset || document.documentElement.scrollTop
		console.log(yOffset);
	}

	function selectVariant(item) {
		selected = {...item}
		step++
	}

	function glassIndex() {
		return glass * 1 - 1
	}

	function getPrice(format = true){
			let price = selected.price[glassIndex()].value

			if(format != true) return price
			return price.toLocaleString('ru-RU')
	}

	function get_weight() {
			let m2 = (selected.size[0] / 1000 ) * (selected.size[1] / 1000)
			
			if(selected.size[2] && selected.size[3]){
					m2 += (selected.size[2] / 1000 ) * (selected.size[3] / 1000)
			}

			m2 *= weight[glassIndex()]		

			return Math.round(m2, 2)
	}

	function get_volume() {
		let m3 = (selected.size[0] / 1000 ) * (selected.size[1] / 1000) * .08
		
		if(selected.size[2] && selected.size[3]){
				m3 += (selected.size[2] / 1000 ) * (selected.size[3] / 1000) * .08
		}		



		return m3
	}

	function urlFramePecom() {
		let url = new URL('https://calc.pecom.ru/iframe/calculator/')
		
		url.searchParams.set('address-from', 'Россия, Орск')
		url.searchParams.set('intake', '1')
		url.searchParams.set('delivery', '1')
		url.searchParams.set('delivery', '1')
		url.searchParams.set('weight', get_weight())
		url.searchParams.set('volume', get_volume())
		url.searchParams.set('declared-amount', getPrice(false))
		url.searchParams.set('transportation-type', 'auto')
		
		return url.toString()
	}

	function urlFrameDe() {
		let url = new URL('https://widgets.dellin.ru/calculator')
		
		url.searchParams.set('group1', 'hide')
		url.searchParams.set('group3', 'hide')
		url.searchParams.set('group4', 'hide')
		url.searchParams.set('group5', 'hide')
		
		url.searchParams.set('derival_to_door', 'off')
		url.searchParams.set('arrival_to_door', 'off')
		url.searchParams.set('package', '1')
		url.searchParams.set('disabled_calculation', 'off')

		url.searchParams.set('derival_point', '5600000400000000000000000')
		
		url.searchParams.set('sized_weight', get_weight())
		url.searchParams.set('sized_volume', get_volume())
		url.searchParams.set('insurance', getPrice(false))
		
		return url.toString()
	}

	console.log(variants, weight);
</script>

<div class="calculator">
		
		{#if step === 1}
		<h5>Выберите тип конструкции:</h5>
		<div class="items">
					{#each variants as variant}		
						<div class="item" on:click={ e => selectVariant(variant)}>
							<Variant {...variant} />
						</div>
					{/each}
		</div>
		{:else if step === 2}
		<div class="glasses">
			<h5>Выберите тип стеклопакета:</h5>

			<label>
					<img src="img/glass2.png" alt="Однокамерный стеклопакет">
					<h6>Однокамерный стеклопакет<br>(2 стекла)</h6>
					
					<input bind:group={glass} value="1"  type="radio" > 
			</label>
			<label>
					<img src="img/glass3.png" alt="Двухкамерный стеклопакет">
					<h6>Двухкамерный стеклопакет<br>(3 стекла)</h6>
					<p></p>
					<input bind:group={glass} value="2" type="radio"> 
			</label>
		</div>
		{:else if step === 3}	
			<div class="result">		
					<h3>{selected.title}</h3>
					<div class="result-img">
						<Variant {...selected } title={false} />
					</div>	
					<div class="result-data">
							<h3>{selected.title}</h3>
							<div class="price">{getPrice()} ₽</div>
							<p>*Без учета стоимости доставки. 
								<span on:click={scroll} class="delivery-on">
										<br>
										Рассчитать стоимость доставки?
								</span>
							</p>

							<button on:click={order} class="btn-projects order">Заказать</button>
					</div>
			</div>
		{/if}

		{#if step > 1}
				<button class="reset" on:click={e => step = 1}>Сбросить</button>
		{/if}
		
		{#if deliverys == true}
			<div class="deliverys">
				<h3>Расчет стоимости доставки:</h3>
				<div class="deliverys-items">

						<div>
								<iframe title="Калькулятор доставки ПЭК" src={urlFramePecom()}></iframe>
						</div>	
						<div>
							<iframe title="Калькулятор доставки Деловые линии" src={urlFrameDe()}>
							</iframe>
						</div>
				</div>
				
			</div>	
		{/if}	
</div>

<style lang="scss">

.calculator{
		--bg-hover: #eef8fdc7;
		
		display: flex;
		flex-wrap: wrap;
		width: 100%;
		max-width: 860px;
		margin: 0 auto;

		img {
			max-width: 100%;
		}

		.reset{
			margin: 20px 0 0 auto;
			border: 0;
			color: red;
			cursor: pointer;
			background: transparent;
			font-size: 13px;
			padding: 0 30px;
		}
	
	}

	.result{
		display: flex;
		flex-wrap: wrap;
		width: 100%;
		
		& > h3{
				display: none;
				text-align: center;
				width: 100%;

				@media (max-width: 768px) {
						display: block;
				}
		}		

		.result-img{
			width: 300px;

			@media (max-width: 768px) {
				margin: 0 auto;
			}
		}
	}

	.result-data{
		padding: 0 15px 0 15px;

		@media (max-width: 768px) {
				width: 100%;
				text-align: center;
		}

		h3{
			font-size: 21px;
			margin: 7px 0 20px 0;
			padding: 0;

			@media (max-width: 768px) {
				display: none;
			}
		}

		p {
			font-style: italic;
		}

		.delivery-on{
			text-decoration: underline;
			color: #267499;
			font-weight: 600;
			cursor: pointer;
		}
	}

	.price{
		font-size: 48px;
    font-weight: 700;
		color: #267499;
	}

	.item {
			width: calc(100% / 3);
			cursor: pointer;
			transition: background-color .3s;
			border-radius: 5px;

			&:hover{
				background-color: var(--bg-hover);
			}		
			
			@media (max-width: 768px) {
				width: 288px;
			}
	}

	.deliverys{
		display: block;
		width: 100%;
		margin-top: 30px;

		h3{
			margin-bottom: 30px;
			@media (max-width: 690px) {
				text-align: center;
			}
		}
		
	}
	.deliverys-items{
		display: flex;
		flex-wrap: wrap;
		width: 100%;		
		justify-content: space-between;

		div{
			width: 50%;
			box-sizing: border-box;
			max-width: 340px;

			&:first-child{
				border: 1px solid #CCC ;
			}

			&:last-child{
				@media (max-width: 690px) {
					height: 160px;
					order: -1; 
					overflow: hidden;
				}				
			}

			@media (max-width: 690px) {
					width: 100%;
					margin: 15px auto;
			}
		}

		iframe{
			width:100%;
			height: 580px;
			border: 0;
			
		}
		
		
	}

	h3{
		font-size: 18px;
		margin: 0;
	}
	
	h5{
			font-size: 18px;
			text-align: center;
			font-weight: 600;
			padding: 0;
			margin: 0 0 15px 0;
			width: 100%;
	}

	.glasses{
		transition: background-color .3s;
		display: flex;
		justify-content: space-between;
		width: 100%;
		flex-wrap: wrap;

		input{
			position: absolute;
			left: 15px;
			top: 15px;
			width: 15px;
			height: 15px;
			opacity: 0;
		}
	}		

	label{
		cursor: pointer;
		position: relative;
		padding: 30px;
		box-sizing: border-box;
		width: 50%;
		display: flex;
		border-radius: 5px;
		align-items: center;

		@media (max-width: 768px) {
			width: 100%;
			border-bottom: solid 1px #ccc;
			padding: 30px 20px;
		}
		
		
		&:hover{
			background-color: var(--bg-hover);
		}

		h6{ 
			font-weight: 500;
			text-align: left;
			margin-bottom: 50px;
		}
	}

	h6 {
		text-align: center;
		font-size: 16px;
		font-weight: normal;
		line-height: 115%;
		padding: 0;
		margin: 0 0 20px;
	}


	.items{
		display: flex;
		flex-wrap: wrap;
		width: 100%;

		justify-content: space-evenly;
	}
			
</style>